"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Subcontact = Subcontact;
var React = _interopRequireWildcard(require("react"));
var _uiKit = require("@cian/ui-kit");
var _clsx = _interopRequireDefault(require("clsx"));
var _internal = require("../ContactAvatar/internal");
var _ContactMainInfo = require("../../../internal/components/ContactMainInfo");
var styles = _interopRequireWildcard(require("./styles.module.css"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const AVATAR_CONTEXT = {
  size: 48
};
/**
 * Компонент для указания подконтакта в Контакте
 * Используется совместно с ContactCard
 *
 * Адаптивный
 * Использует useDeviceType из ui-kit
 * В малой (до 374px) мобильной версии не выводятся иконки около имени,
 * а все элементы выстраиваются вертикально и центрируются
 */
function Subcontact(_ref) {
  let {
    title,
    name,
    href,
    target,
    onNameClick,
    nameIcons,
    avatar,
    labels,
    qualityInfo
  } = _ref;
  const deviceType = (0, _uiKit.useDeviceType)();
  return /*#__PURE__*/React.createElement("div", {
    className: (0, _clsx.default)(styles['subcontact'], deviceType === 'phone' && styles['mobile'])
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['avatar']
  }, /*#__PURE__*/React.createElement(_internal.ContactAvatarContext.Provider, {
    value: AVATAR_CONTEXT
  }, avatar)), /*#__PURE__*/React.createElement("div", {
    className: styles['contact']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['main-info']
  }, /*#__PURE__*/React.createElement(_ContactMainInfo.ContactMainInfo, {
    NameHeadingComponent: _uiKit.UIHeading4,
    title: title,
    name: name,
    href: href,
    target: target,
    onNameClick: onNameClick,
    nameIcons: nameIcons,
    qualityInfo: qualityInfo
  })), labels));
}